module.exports = __webpack_public_path__ + "Proxima Nova Bold.62d4d7d369292a9bf237.svg";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/ucla-prrla/ucla-prrla/ucla-prrla/fonts/Proxima Nova Bold.svg
// module id = ../../../../../fonts/Proxima Nova Bold.svg
// module chunks = 2